// extracted by mini-css-extract-plugin
export default {"header":"HeaderPictureMain_header__3qW5y","picture":"HeaderPictureMain_picture__w-ZR5","pictureMobile":"HeaderPictureMain_pictureMobile__Zq2o9"};